// extracted by mini-css-extract-plugin
module.exports = {"class":"ClassItem_class__m1RuZ","classContent":"ClassItem_classContent__32D_R","classTitle":"ClassItem_classTitle__2otNx","classSubTitle":"ClassItem_classSubTitle__12Tkh"};